import React, { useState, useEffect } from 'react';
import {
  Select,
  Text,
  Box,
  Loader,
  Group
} from '@mantine/core';
import config from '../../../../config.js';
import useAuthenticatedData from '../../../../hooks/useAuthenticatedData';

const RepairsPersonSelect = ({ onPersonSelect, defaultPersonCode }) => {
  const [selectedPersonCode, setSelectedPersonCode] = useState('');

  // Custom hook to fetch authenticated data
  const { data: people, isLoading, error: fetchError } = useAuthenticatedData(
    `${config.apiBaseUrl}/supply-chain/repairs/individual/get-repair-coordinators`
  );

  // Handle default person selection when data loads
  useEffect(() => {
    if (!isLoading && people && people.length > 0 && defaultPersonCode) {
      const defaultPerson = people.find(person => person.cCode === defaultPersonCode);
      if (defaultPerson) {
        setSelectedPersonCode(defaultPersonCode);
        onPersonSelect(defaultPerson);
      }
    }
  }, [people, isLoading, defaultPersonCode, onPersonSelect]);

  const handlePersonChange = (selectedCode) => {
    setSelectedPersonCode(selectedCode);

    const selectedPerson = people?.find(person => person.cCode === selectedCode);
    if (selectedPerson) {
      console.log('Selected person:', selectedPerson);
      onPersonSelect(selectedPerson);
    }
  };

  if (isLoading) {
    return (
      <Group gap="xs" style={{ marginRight: '16px' }}>
        <Loader size="sm" />
        <Text size="sm" c="white">Loading people...</Text>
      </Group>
    );
  }

  if (fetchError) {
    return (
      <Text size="sm" c="red" style={{ marginRight: '16px' }}>
        Error: {fetchError}
      </Text>
    );
  }

  // Prepare data for Mantine Select
  const selectData = people?.map((person) => ({
    value: person.cCode,
    label: `${person.fullName} (${person.cCode})`
  })) || [];

  return (
    <Select
      placeholder="Select a Person"
      value={selectedPersonCode}
      onChange={handlePersonChange}
      data={selectData}
      size="sm"
      style={{ 
        minWidth: 200, 
        marginRight: '16px'
      }}
      styles={{
        input: {
          color: 'white',
          backgroundColor: 'transparent',
          borderColor: 'rgba(255, 255, 255, 0.23)',
          '&:hover': {
            borderColor: 'rgba(255, 255, 255, 0.5)',
          },
          '&:focus': {
            borderColor: '#FDB813',
          },
        },
        rightSection: {
          color: 'white',
        },
        dropdown: {
          backgroundColor: '#424242',
          border: '1px solid rgba(255, 255, 255, 0.23)',
        },
        option: {
          color: 'white',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
          },
          '&[data-selected]': {
            backgroundColor: '#FDB813',
            color: 'black',
            '&:hover': {
              backgroundColor: '#FDB813',
            },
          },
        },
      }}
      clearable
    />
  );
};

export default RepairsPersonSelect;